import { render } from "./DialogCanNotChangePurchasedTicket.vue?vue&type=template&id=6c2dff3c"
import script from "./DialogCanNotChangePurchasedTicket.vue?vue&type=script&lang=js"
export * from "./DialogCanNotChangePurchasedTicket.vue?vue&type=script&lang=js"
script.render = render

export default script